import React, { useState } from "react"
import { AnnouncementPopup } from "letalkui"

import { renderComponent } from "@/utils/node"
import { whatsappLinks } from "@/utils/link"

import AdvancedDeploymentBanner from "@/assets/images/banners/advanced-deployment-banner.png"

type AdvancedDeploymentDialogProps = Record<string, never>

type AdvancedDeploymentDialogType = {
	open: (props?: AdvancedDeploymentDialogProps) => void
}

const ADVANCED_DEPLOYMENT_IMAGE = AdvancedDeploymentBanner
const ADVANCED_DEPLOYMENT_TITLE = "Implantação avançada"

const AdvancedDeploymentDialog: AdvancedDeploymentDialogType & React.FC<AdvancedDeploymentDialogProps> = () => {
	const [opened, setOpened] = useState(true)

	const handleClose = () => {
		setOpened(false)
	}

	const handleTalkToLetalk = () => {
		window.open(whatsappLinks.sendMessageForAdvancedImportDeployment, "_blank")
		handleClose()
	}

	return (
		<AnnouncementPopup
			open={opened}
			onClose={handleClose}
			onClosePermanently={handleClose}
			shouldHideDoNotShowAgain
			announcement={{
				type: "advanced-import-deployment",
				image: ADVANCED_DEPLOYMENT_IMAGE,
				title: ADVANCED_DEPLOYMENT_TITLE,
				body: "Não quer configurar a importação sozinho? Um especialista da Letalk cuida de toda a implantação junto com o seu time — importação, automações e boas práticas, do começo ao fim.",
				confirmButtonText: "Falar com a Letalk",
				onAction: handleTalkToLetalk
			}}
		/>
	)
}

AdvancedDeploymentDialog.open = (props = {}) => {
	renderComponent(
		"advanced-deployment-dialog",
		<AdvancedDeploymentDialog
			{...props}
		/>
	)
}

export default AdvancedDeploymentDialog
